<mat-toolbar>
  <span>Appointment Tools</span>
  <span class="toolbar-spacer"></span>
  <button mat-fab extended (click)="openAppointmentBuilder()">
    <mat-icon>add</mat-icon>
    Create Appointment
  </button>
</mat-toolbar>